<template>
  <Grid>
    <GridItem
      v-for="feature in features"
      :key="feature"
      :gridSpan="4"
    >
      <HeadingSmall
        :class="$style.feature"
        weight="normal"
      >
        <Icon
          icon="checkmarkCircle"
          :inline="true"
        />
        {{ feature }}
      </HeadingSmall>
    </GridItem>
  </Grid>
</template>

<script>
import {
  Grid,
  GridItem,
  HeadingSmall,
  Icon,
} from '@jumpcloud/ui-components';

export default {
  name: 'FeaturesGrid',

  components: {
    Grid,
    GridItem,
    HeadingSmall,
    Icon,
  },

  props: {
    features: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style module>
.feature {
  padding-left: var(--jc-spacer);
}
</style>
